import { GoChevronDown } from "react-icons/go";
import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useRef } from "react";
import { RxCross2 } from "react-icons/rx";

const FilterModal = ({ filterItems,search,setSearch, setFilterItems, toggleRef,handleSearchToggle, onOptionClick, onClose }) => {

    const modalRef = useRef(null);


    useEffect(() => {
        function handleClickOutside(e) {
            if (modalRef.current && modalRef.current.contains(e.target)) return;
            if (toggleRef?.current && toggleRef.current.contains(e.target)) return;
            onClose();

            setFilterItems(prev =>
                prev.map(item => ({
                    ...item,
                    enable: false
                }))
            );
        }
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, [onClose, toggleRef]);





    function handleRemoveFilter(e,index){
        e.stopPropagation()
        setFilterItems(prev =>
            prev.map((item, idx) =>
                idx === index
                    ? {
                        ...item,
                        selected: "",
                        selectedVal: null,
                        enable: false
                    }
                    : item
            )
        );
    }

    return (
        <div
            ref={modalRef}
            className="absolute flex flex-col gap-2 w-[300px] py-5 animate-openSideBar
      shadow-2xl drop-shadow-2xl overflow-y-scroll
      left-4 z-40 top-10 bg-white max-h-[500px] rounded-2xl
      border-[1px] border-gray-200"    >
            {filterItems?.map((it, index) => (
                <div key={index}>

                    <div

                        onClick={() => {
                            setFilterItems((prev) =>
                                prev.map((item, idx) =>
                                    idx === index ? { ...item, enable: !item.enable } : { ...item, enable: false }
                                )
                            );
                        }}
                        className="w-full h-max text-gray-400 px-2 py-1 flex flex-row justify-between items-center"
                    >
                        <p className={ `${it?.selected ? "text-[14px]":"text-[18px]"} text-gray-400   whitespace-nowrap`}>
                            {it.selected ? it.selected : it.main}
                        </p>

                        <div className="flex max-w-[200px] h-[30px] flex-row gap-3 justify-end items-center">
                            {it?.enable && it?.hasSearch && (
                                <motion.div
                                    initial={{ x: 50, opacity: 0 }}
                                    animate={{ x: 0, opacity: 1 }}
                                    exit={{ x: 50, opacity: 0 }}
                                    transition={{ duration: 0.4, ease: "easeOut" }}
                                    className="h-full w-full"
                                >
                                    <input
                                        className="rounded-3xl flex flex-col outline-special justify-center items-center h-full w-full border-[1px] px-5 text-[14px] text-gray-600 lg:text-[16px] border-gray-300"
                                        type="text"
                                        value={search}
                                        onClick={(e) => e.stopPropagation()}
                                        placeholder="جست و جو"
                                        onChange={(e) =>{ handleSearchToggle(e.target.value, index) ; setSearch(e.target.value)}}
                                    />
                                </motion.div>
                            )}
                            {
                                (it?.selected=="" || it?.selected==null)?
                                    <GoChevronDown
                                        size={20}
                                        className={`${it.enable && "rotate-180 "} transition-all duration-200`}
                                    />
                                    :
                                    <RxCross2 onClick={(e)=>handleRemoveFilter(e,index)} size={15}></RxCross2>



                            }

                        </div>
                    </div>

                    {/* subItems */}
                    {it.enable && (
                        <AnimatePresence>
                            <motion.div
                                initial={{ x: 50, opacity: 0 }}
                                animate={{ x: 0, opacity: 1 }}
                                exit={{ x: 50, opacity: 0 }}
                                transition={{ duration: 0.4, ease: "easeOut" }}
                                className="flex flex-col px-4 gap-1 custom-scroll text-md max-h-[200px] overflow-y-auto overflow-x-hidden"
                            >
                                <ul dir="rtl" className="list-disc list-inside space-y-[5px]">
                                    {it?.sub?.map((subItem, indx) => (
                                        <li
                                            key={indx}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onOptionClick(it.main, subItem, index);
                                            }}
                                            className="text-gray-500 text-[14px] cursor-pointer"
                                        >
                                            {(subItem?.label) ? subItem?.label+"-"+subItem?.name :subItem?.name}
                                        </li>
                                    ))}
                                </ul>
                            </motion.div>
                        </AnimatePresence>
                    )}
                </div>
            ))}
        </div>
    );
};

export default FilterModal;
